import { useState, useRef, useContext, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import PermissionGate from "../layout/PermissionGate";
import normalize from "../utils/NormalizeSelect";

const CreateDriver = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStep, setLoadingStep] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const profileInputRef = useRef(null);
  const contractInputRef = useRef(null);
  const govtIdInputRef = useRef(null);
  const licenceInputRef = useRef(null);
  const vehicleInputRef = useRef(null);
  const token = localStorage.getItem("token");

  const fetchDelivaryCompanies = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}all-delivary-companies`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setCompanies(res.data.data);
        }
      })
      .catch(console.error);
  };
  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "select") {
      const value = event.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "date") {
      const value = moment(event).format("DD-MM-YYYY");
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "file") {
      setLoadingStep(field);
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64 = reader.result.split(",")[1];
          const extensionMatch = file.name.match(/\.([^.]+)$/);
          const extension = extensionMatch[1].toLowerCase();
          const fileName = file.name;
          const fileObject = {
            type: extension,
            content: base64,
            fileName: fileName,
          };
          axios
            .post(
              process.env.REACT_APP_API_ENDPOINT + "upload-file",
              {
                file: fileObject,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((res) => {
              const newData = { ...data };
              newData[field] = res.data.data;
              const newError = { ...error };
              newError[field] = "";
              delete newError[field];
              setData({ ...newData });
              setError({ ...newError });
              setLoadingStep("");
            })
            .catch((error) => {
              console.error(error);
            });
        };
        reader.readAsDataURL(file);
      }
    }
    if (type === "switch") {
      const value = event.target.checked;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "gender" || type === "vehicleType") {
      const value = event;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
  };
  const addDriver = () => {
    const errors = {};
    if (data.name === undefined || data.name === "") {
      errors["name"] = "Please enter name";
    }
    if (data.email === undefined || data.email === "") {
      errors["email"] = "Please enter email";
    }
    if (data.workPhone === undefined || data.workPhone === "") {
      errors["workPhone"] = "Please enter phone no";
    }
    if (data.personalPhone === undefined || data.personalPhone === "") {
      errors["personalPhone"] = "Please enter phone no";
    }
    if (data.dob === undefined || data.dob === "") {
      errors["dob"] = "Please select a date";
    }
    if (data.gender === undefined || data.gender === "") {
      errors["gender"] = "Please select gender";
    }
    if (data.profilePhoto === undefined || data.profilePhoto === "") {
      errors["profilePhoto"] = "Please upload profile photo";
    }
    if (data.type === undefined || data.type === "") {
      errors["type"] = "Please select type";
    }
    if (data.type === "Delivary Company Fleet Member") {
      if (
        data.delivaryCompanyId === undefined ||
        data.delivaryCompanyId === ""
      ) {
        errors["delivaryCompanyId"] = "Please select company";
      }
    }
    if (data.country === undefined || data.country === "") {
      errors["country"] = "Please select country";
    }
    if (data.govtIdType === undefined || data.govtIdType === "") {
      errors["govtIdType"] = "Please select govt id type";
    }
    if (data.govtIdCountry === undefined || data.govtIdCountry === "") {
      errors["govtIdCountry"] = "Please select govt id country";
    }
    if (data.govtIdNo === undefined || data.govtIdNo === "") {
      errors["govtIdNo"] = "Please enter govt id no";
    }
    if (data.govtIdExpiaryDate === undefined || data.govtIdExpiaryDate === "") {
      errors["govtIdExpiaryDate"] = "Please select a date";
    }
    if (data.govtIdPhoto === undefined || data.govtIdPhoto === "") {
      errors["govtIdPhoto"] = "Please upload govt id photo";
    }
    if (data.licenceNo === undefined || data.licenceNo === "") {
      errors["licenceNo"] = "Please enter licence no";
    }
    if (data.licenceCountry === undefined || data.licenceCountry === "") {
      errors["licenceCountry"] = "Please select licence country";
    }
    if (data.licenceIssueDate === undefined || data.licenceIssueDate === "") {
      errors["licenceIssueDate"] = "Please select a date";
    }
    if (
      data.licenceExpiaryDate === undefined ||
      data.licenceExpiaryDate === ""
    ) {
      errors["licenceExpiaryDate"] = "Please select a date";
    }
    if (data.licencePhoto === undefined || data.licencePhoto === "") {
      errors["licencePhoto"] = "Please upload licence photo";
    }
    if (data.vehicleType === undefined || data.vehicleType === "") {
      errors["vehicleType"] = "Please select vehicle type";
    }
    if (data.vehicleMake === undefined || data.vehicleMake === "") {
      errors["vehicleMake"] = "Please enter vehicle make";
    }
    if (data.vehicleModel === undefined || data.vehicleModel === "") {
      errors["vehicleModel"] = "Please enter vehicle model";
    }
    if (data.vehicleYear === undefined || data.vehicleYear === "") {
      errors["vehicleYear"] = "Please enter vehicle year";
    }
    if (data.vehiclePlate === undefined || data.vehiclePlate === "") {
      errors["vehiclePlate"] = "Please enter vehicle plate";
    }
    if (
      data.vehicleRegistration === undefined ||
      data.vehicleRegistration === ""
    ) {
      errors["vehicleRegistration"] = "Please enter vehicle registration";
    }
    if (data.vehicleDocument === undefined || data.vehicleDocument === "") {
      errors["vehicleDocument"] = "Please upload vehicle document";
    }
    setError({ ...errors });
    console.log(errors);
    if (
      errors.name === undefined &&
      errors.email === undefined &&
      errors.workPhone === undefined &&
      errors.personalPhone === undefined &&
      errors.dob === undefined &&
      errors.gender === undefined &&
      errors.profilePhoto === undefined &&
      errors.type === undefined &&
      errors.delivaryCompanyId === undefined &&
      errors.country === undefined &&
      errors.govtIdType === undefined &&
      errors.govtIdCountry === undefined &&
      errors.govtIdNo === undefined &&
      errors.govtIdExpiaryDate === undefined &&
      errors.govtIdPhoto === undefined &&
      errors.licenceNo === undefined &&
      errors.licenceCountry === undefined &&
      errors.licenceIssueDate === undefined &&
      errors.licenceExpiaryDate === undefined &&
      errors.licencePhoto === undefined &&
      errors.vehicleType === undefined &&
      errors.vehicleMake === undefined &&
      errors.vehicleModel === undefined &&
      errors.vehicleYear === undefined &&
      errors.vehiclePlate === undefined &&
      errors.vehicleRegistration === undefined &&
      errors.vehicleDocument === undefined
    ) {
      axios
        .post(process.env.REACT_APP_API_ENDPOINT + "create-driver", data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              reset();
            }
          }
        })
        .catch(console.error);
    }
  };
  const reset = () => {
    if (profileInputRef.current) {
      profileInputRef.current.value = "";
    }
    if (contractInputRef.current) {
      contractInputRef.current.value = "";
    }
    if (govtIdInputRef.current) {
      govtIdInputRef.current.value = "";
    }
    if (licenceInputRef.current) {
      licenceInputRef.current.value = "";
    }
    if (vehicleInputRef.current) {
      vehicleInputRef.current.value = "";
    }

    setData({});
  };

  useEffect(() => {
    fetchDelivaryCompanies();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Add New Driver
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <PermissionGate required={`create_new_driver`}>
                  <form
                    action="javascript:void(0)"
                    autocomplete="off"
                    id="addNewDriverForm"
                    enctype="multipart/form-data"
                  >
                    {/* Start:Driver profile */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Driver profile</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3 fv-row">
                              <label className="form-label required">
                                Full Name
                              </label>
                              <input
                                id="name"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter driver name"
                                data-error="* Please Enter Driver Name"
                                value={data?.name ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "name");
                                }}
                              />
                              {error.name !== undefined && error.name !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.name}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Email
                              </label>
                              <input
                                id="email"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter driver email"
                                data-error="* Please Enter Driver Email"
                                value={data?.email ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "email");
                                }}
                              />
                              {error.email !== undefined &&
                                error.email !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.email}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Work Phone
                              </label>
                              <input
                                id="work_phone"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Driver work phone"
                                data-error="* Enter Driver Work Phone"
                                value={data?.workPhone ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "workPhone");
                                }}
                              />
                              {error.workPhone !== undefined &&
                                error.workPhone !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.workPhone}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Personal Phone
                              </label>
                              <input
                                id="personal_phone"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Driver personal phone"
                                data-error="* Enter Driver Personal Phone"
                                value={data?.personalPhone ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "personalPhone");
                                }}
                              />
                              {error.personalPhone !== undefined &&
                                error.personalPhone !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.personalPhone}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Date of Birth
                              </label>
                              <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={data?.dob ?? ""}
                                onChange={([dob]) => {
                                  processData("date", dob, "dob");
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.dob !== undefined && error.dob !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.dob}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Select Gender
                              </label>
                              {/*begin::Row*/}
                              <div className="fv-row">
                                {/*begin::Radio group*/}
                                <div
                                  className="btn-group w-100"
                                  data-kt-buttons="true"
                                  data-kt-buttons-target="[data-kt-button]"
                                >
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.gender === "Male"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-driver-field"
                                      type="radio"
                                      value="Male"
                                      data-error="* Please Select Gender"
                                      onClick={() => {
                                        processData("gender", "Male", "gender");
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Male
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.gender === "Female"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-driver-field"
                                      type="radio"
                                      value="Female"
                                      data-error="* Please Select Gender"
                                      onClick={() => {
                                        processData(
                                          "gender",
                                          "Female",
                                          "gender"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Female
                                  </label>
                                  {/*end::Radio*/}
                                </div>
                                {/*end::Radio group*/}
                              </div>
                              {error.gender !== undefined &&
                                error.gender !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.gender}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Profile Photo
                              </label>
                              <input
                                id="profile_photo"
                                type="file"
                                accept="image/*"
                                className="form-control add-driver-field"
                                data-error="* Please Upload Profile Photo"
                                ref={profileInputRef}
                                onChange={(e) => {
                                  processData("file", e, "profilePhoto");
                                }}
                              />
                              {error.profilePhoto !== undefined &&
                                error.profilePhoto !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.profilePhoto}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "profilePhoto" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Select Country
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.country === undefined
                                    ? null
                                    : {
                                      value: data.country,
                                      label: data.country,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "country");
                                }}
                                options={[
                                  {
                                    value: "Kuwait",
                                    label: "Kuwait",
                                  },
                                  {
                                    value: "Jordan",
                                    label: "Jordan",
                                  },
                                  {
                                    value: "Bahrain",
                                    label: "Bahrain",
                                  },
                                  {
                                    value: "Qatar",
                                    label: "Qatar",
                                  },
                                  {
                                    value: "Saudi Arabia",
                                    label: "Saudi Arabia",
                                  },
                                  {
                                    value: "United Arab Emirates",
                                    label: "United Arab Emirates",
                                  },
                                  {
                                    value: "Tunisia",
                                    label: "Tunisia",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.country !== undefined &&
                                error.country !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.country}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Driver Type
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.type === undefined
                                    ? null
                                    : {
                                      value: data.type,
                                      label: data.type,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "type");
                                }}
                                options={[
                                  {
                                    value: "Freelance",
                                    label: "Freelance",
                                  },
                                  {
                                    value: "Ahmadi Core Support Driver",
                                    label: "Ahmadi Core Support Driver",
                                  },
                                  {
                                    value: "Delivery Company Fleet Member",
                                    label: "Delivery Company Fleet Member",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.type !== undefined && error.type !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.type}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            {data?.type === "Delivery Company Fleet Member" ? (
                              <div className="col-md-4 mb-3">
                                <label className="form-label required">
                                  Delivery Company
                                </label>
                                <Select
                                  className="react-select-styled react-select-bordered"
                                  classNamePrefix="react-select"
                                  value={
                                    data.delivaryCompanyId === undefined
                                      ? null
                                      : companies.find(
                                        (company) =>
                                          company?._id ===
                                          data.delivaryCompanyId
                                      )
                                        ? {
                                          value: data.delivaryCompanyId,
                                          label: companies.find(
                                            (company) =>
                                              company?._id ===
                                              data.delivaryCompanyId
                                          )?.name,
                                        }
                                        : null
                                  }
                                  onChange={(e) => {
                                    processData(
                                      "select",
                                      e,
                                      "delivaryCompanyId"
                                    );
                                  }}
                                  options={companies?.map((company) => {
                                    return {
                                      value: company?._id,
                                      label: company?.name,
                                    };
                                  })}
                                  filterOption={(option, input) => {
                                    return normalize(option.label).includes(normalize(input));
                                  }}
                                  placeholder="Select an option"
                                />
                                {error.delivaryCompanyId !== undefined &&
                                  error.delivaryCompanyId !== "" ? (
                                  <small className="text-danger mt-2">
                                    {error.delivaryCompanyId}
                                  </small>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Driver profile */}
                    {/* Start:Driver Preferences */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Driver Preferences</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Work Start From
                              </label>
                              <input
                                id="working_from"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Work Start From"
                                data-error="* Please Select Starting Time"
                                value={data?.workFrom ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "workFrom");
                                }}
                              />
                              {error.workFrom !== undefined &&
                                error.workFrom !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.workFrom}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Work End At
                              </label>
                              <input
                                id="working_to"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Work End At"
                                data-error="* Select Shift Ending Time"
                                value={data?.workTo ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "workTo");
                                }}
                              />
                              {error.workTo !== undefined &&
                                error.workTo !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.workTo}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Time Zone
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.timeZone === undefined
                                    ? null
                                    : {
                                      value: data.timeZone,
                                      label: data.timeZone,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "timeZone");
                                }}
                                options={[
                                  {
                                    value: "UTC-12",
                                    label: "UTC-12",
                                  },
                                  {
                                    value: "UTC-11",
                                    label: "UTC-11",
                                  },
                                  {
                                    value: "UTC-10",
                                    label: "UTC-10",
                                  },
                                  {
                                    value: "UTC-09:30",
                                    label: "UTC-09:30",
                                  },
                                  {
                                    value: "UTC-9",
                                    label: "UTC-9",
                                  },
                                  {
                                    value: "UTC-8",
                                    label: "UTC-8",
                                  },
                                  {
                                    value: "UTC-7",
                                    label: "UTC-7",
                                  },
                                  {
                                    value: "UTC-6",
                                    label: "UTC-6",
                                  },
                                  {
                                    value: "UTC-5",
                                    label: "UTC-5",
                                  },
                                  {
                                    value: "UTC-4",
                                    label: "UTC-4",
                                  },
                                  {
                                    value: "UTC-03:30",
                                    label: "UTC-03:30",
                                  },
                                  {
                                    value: "UTC-3",
                                    label: "UTC-3",
                                  },
                                  {
                                    value: "UTC-2",
                                    label: "UTC-2",
                                  },
                                  {
                                    value: "UTC-1",
                                    label: "UTC-1",
                                  },
                                  {
                                    value: "UTC",
                                    label: "UTC",
                                  },
                                  {
                                    value: "UTC+1",
                                    label: "UTC+1",
                                  },
                                  {
                                    value: "UTC+2",
                                    label: "UTC+2",
                                  },
                                  {
                                    value: "UTC+3",
                                    label: "UTC+3",
                                  },
                                  {
                                    value: "UTC+03:30",
                                    label: "UTC+03:30",
                                  },
                                  {
                                    value: "UTC+4",
                                    label: "UTC+4",
                                  },
                                  {
                                    value: "UTC+04:30",
                                    label: "UTC+04:30",
                                  },
                                  {
                                    value: "UTC+5",
                                    label: "UTC+5",
                                  },
                                  {
                                    value: "UTC+05:30",
                                    label: "UTC+05:30",
                                  },
                                  {
                                    value: "UTC+05:45",
                                    label: "UTC+05:45",
                                  },
                                  {
                                    value: "UTC+6",
                                    label: "UTC+6",
                                  },
                                  {
                                    value: "UTC+06:30",
                                    label: "UTC+06:30",
                                  },
                                  {
                                    value: "UTC+7",
                                    label: "UTC+7",
                                  },
                                  {
                                    value: "UTC+8",
                                    label: "UTC+8",
                                  },
                                  {
                                    value: "UTC+08:30",
                                    label: "UTC+08:30",
                                  },
                                  {
                                    value: "UTC+08:45",
                                    label: "UTC+08:45",
                                  },
                                  {
                                    value: "UTC+9",
                                    label: "UTC+9",
                                  },
                                  {
                                    value: "UTC+09:30",
                                    label: "UTC+09:30",
                                  },
                                  {
                                    value: "UTC+10",
                                    label: "UTC+10",
                                  },
                                  {
                                    value: "UTC+10:30",
                                    label: "UTC+10:30",
                                  },
                                  {
                                    value: "UTC+11",
                                    label: "UTC+11",
                                  },
                                  {
                                    value: "UTC+12",
                                    label: "UTC+12",
                                  },
                                  {
                                    value: "UTC+12:45",
                                    label: "UTC+12:45",
                                  },
                                  {
                                    value: "UTC+13",
                                    label: "UTC+13",
                                  },
                                  {
                                    value: "UTC+14",
                                    label: "UTC+14",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.timeZone !== undefined &&
                                error.timeZone !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.timeZone}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Maximum Travel Distance
                              </label>
                              <input
                                id="max_travel_distance"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Maximum Travel Distance"
                                data-error="* Please Enter Max Travel Capacity"
                                value={data?.maxTravelDistance ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "maxTravelDistance");
                                }}
                              />
                              {error.maxTravelDistance !== undefined &&
                                error.maxTravelDistance !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.maxTravelDistance}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Station
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.station === undefined
                                    ? null
                                    : {
                                      value: data.station,
                                      label: data.station,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "station");
                                }}
                                options={[
                                  {
                                    value: "Avenues",
                                    label: "Avenues",
                                  },
                                  {
                                    value: "Ardhiya",
                                    label: "Ardhiya",
                                  },
                                  {
                                    value: "Aswaq Al Qurain",
                                    label: "Aswaq Al Qurain",
                                  },
                                  {
                                    value: "Abu Al Hasaniya",
                                    label: "Abu Al Hasaniya",
                                  },
                                  {
                                    value: " Mahboula, Fintas, Eigala",
                                    label: " Mahboula, Fintas, Eigala",
                                  },

                                  {
                                    value: "Salmiya and Bidaa",
                                    label: "Salmiya and Bidaa",
                                  },
                                  {
                                    value: "Shaab",
                                    label: "Shaab",
                                  },
                                  {
                                    value: "Jabriya",
                                    label: "Jabriya",
                                  },
                                  {
                                    value: "Al Rai",
                                    label: "Al Rai",
                                  },
                                  {
                                    value: "Jahra",
                                    label: "Jahra",
                                  },
                                  {
                                    value: "Kuwait City",
                                    label: "Kuwait City",
                                  },
                                  {
                                    value: "Kuwait",
                                    label: "Kuwait",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.station !== undefined &&
                                error.station !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.station}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Display Balance
                              </label>
                              <div className="form-check form-switch form-check-custom">
                                <input
                                  className="form-check-input add-driver-field mt-3"
                                  type="checkbox"
                                  value={data?.displayBalance ?? ""}
                                  checked={data?.displayBalance ?? false}
                                  onChange={(e) => {
                                    processData("switch", e, "displayBalance");
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Driver Preferences */}
                    {/* Start:Government ID */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Government ID</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Document Type
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.govtIdType === undefined
                                    ? null
                                    : {
                                      value: data.govtIdType,
                                      label: data.govtIdType,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "govtIdType");
                                }}
                                options={[
                                  {
                                    value: "Civil Id",
                                    label: "Civil Id",
                                  },
                                  {
                                    value: "Passport",
                                    label: "Passport",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.govtIdType !== undefined &&
                                error.govtIdType !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.govtIdType}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Country
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.govtIdCountry === undefined
                                    ? null
                                    : {
                                      value: data.govtIdCountry,
                                      label: data.govtIdCountry,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "govtIdCountry");
                                }}
                                options={[
                                  {
                                    value: "Kuwait",
                                    label: "Kuwait",
                                  },
                                  {
                                    value: "Jordan",
                                    label: "Jordan",
                                  },
                                  {
                                    value: "Bahrain",
                                    label: "Bahrain",
                                  },
                                  {
                                    value: "Qatar",
                                    label: "Qatar",
                                  },
                                  {
                                    value: "Saudi Arabia",
                                    label: "Saudi Arabia",
                                  },
                                  {
                                    value: "United Arab Emirates",
                                    label: "United Arab Emirates",
                                  },
                                  {
                                    value: "Tunisia",
                                    label: "Tunisia",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.govtIdCountry !== undefined &&
                                error.govtIdCountry !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.govtIdCountry}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Id Number
                              </label>
                              <input
                                id="govt_id_no"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Govt. Id Number"
                                data-error="* Please Enter Id Number"
                                value={data?.govtIdNo ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "govtIdNo");
                                }}
                              />
                              {error.govtIdNo !== undefined &&
                                error.govtIdNo !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.govtIdNo}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Expiary Date
                              </label>
                              <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={data?.govtIdExpiaryDate ?? ""}
                                onChange={([govtIdExpiaryDate]) => {
                                  processData(
                                    "date",
                                    govtIdExpiaryDate,
                                    "govtIdExpiaryDate"
                                  );
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.govtIdExpiaryDate !== undefined &&
                                error.govtIdExpiaryDate !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.govtIdExpiaryDate}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Govt. Id Photo
                              </label>
                              <input
                                id="govt_id_photo"
                                type="file"
                                className="form-control add-driver-field"
                                placeholder="Govt. Id Photo"
                                data-error="* Please Upload Id"
                                ref={govtIdInputRef}
                                onChange={(e) => {
                                  processData("file", e, "govtIdPhoto");
                                }}
                              />
                              {error.govtIdPhoto !== undefined &&
                                error.govtIdPhoto !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.govtIdPhoto}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "govtIdPhoto" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Government ID */}
                    {/* Start:Driver licence */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Driver licence</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Licence No
                              </label>
                              <input
                                id="licence_no"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Driver Licence No"
                                data-error="* Enter Licence Number"
                                value={data?.licenceNo ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "licenceNo");
                                }}
                              />
                              {error.licenceNo !== undefined &&
                                error.licenceNo !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licenceNo}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Country
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.licenceCountry === undefined
                                    ? null
                                    : {
                                      value: data.licenceCountry,
                                      label: data.licenceCountry,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "licenceCountry");
                                }}
                                options={[
                                  {
                                    value: "Kuwait",
                                    label: "Kuwait",
                                  },
                                  {
                                    value: "Jordan",
                                    label: "Jordan",
                                  },
                                  {
                                    value: "Bahrain",
                                    label: "Bahrain",
                                  },
                                  {
                                    value: "Qatar",
                                    label: "Qatar",
                                  },
                                  {
                                    value: "Saudi Arabia",
                                    label: "Saudi Arabia",
                                  },
                                  {
                                    value: "United Arab Emirates",
                                    label: "United Arab Emirates",
                                  },
                                  {
                                    value: "Tunisia",
                                    label: "Tunisia",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.licenceCountry !== undefined &&
                                error.licenceCountry !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licenceCountry}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Licence Issue Date
                              </label>
                              <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={data?.licenceIssueDate ?? ""}
                                onChange={([licenceIssueDate]) => {
                                  processData(
                                    "date",
                                    licenceIssueDate,
                                    "licenceIssueDate"
                                  );
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.licenceIssueDate !== undefined &&
                                error.licenceIssueDate !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licenceIssueDate}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Licence Expiary Date
                              </label>
                              <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={data?.licenceExpiaryDate ?? ""}
                                onChange={([licenceExpiaryDate]) => {
                                  processData(
                                    "date",
                                    licenceExpiaryDate,
                                    "licenceExpiaryDate"
                                  );
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.licenceExpiaryDate !== undefined &&
                                error.licenceExpiaryDate !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licenceExpiaryDate}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Licence Photo
                              </label>
                              <input
                                id="licence_photo"
                                type="file"
                                className="form-control add-driver-field"
                                placeholder="Upload Licence"
                                data-error="* Upload Licence Photo"
                                ref={licenceInputRef}
                                onChange={(e) => {
                                  processData("file", e, "licencePhoto");
                                }}
                              />
                              {error.licencePhoto !== undefined &&
                                error.licencePhoto !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licencePhoto}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "licencePhoto" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Driver licence */}
                    {/* Start:Bank account */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Bank account</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Bank Name
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.bankName === undefined
                                    ? null
                                    : {
                                      value: data.bankName,
                                      label: data.bankName,
                                    }
                                }
                                onChange={(e) => {
                                  processData("select", e, "bankName");
                                }}
                                options={[
                                  {
                                    value: "Al Ahli Bank of Kuwait (ABK)",
                                    label: "Al Ahli Bank of Kuwait (ABK)",
                                  },
                                  {
                                    value: "Ahli United Bank (AUB)",
                                    label: "Ahli United Bank (AUB)",
                                  },
                                  {
                                    value: "Bank of Bahrain & Kuwait (BBK)",
                                    label: "Bank of Bahrain & Kuwait (BBK)",
                                  },
                                  {
                                    value: "Boubyan Bank (Boubyan)",
                                    label: "Boubyan Bank (Boubyan)",
                                  },
                                  {
                                    value: "Burgan Bank (Burgan)",
                                    label: "Burgan Bank (Burgan)",
                                  },
                                  {
                                    value: "Commercial Bank of Kuwait (CBK)",
                                    label: "Commercial Bank of Kuwait (CBK)",
                                  },
                                  {
                                    value: "Doha Bank (Doha)",
                                    label: "Doha Bank (Doha)",
                                  },
                                  {
                                    value: "Gulf Bank of Kuwait (GBK)",
                                    label: "Gulf Bank of Kuwait (GBK)",
                                  },
                                  {
                                    value: "Kuwait Finance House (KFH)",
                                    label: "Kuwait Finance House (KFH)",
                                  },
                                  {
                                    value: "Kuwait International Bank (KIB)",
                                    label: "Kuwait International Bank (KIB)",
                                  },
                                  {
                                    value: "Mashreq Bank (Mashreq)",
                                    label: "Mashreq Bank (Mashreq)",
                                  },
                                  {
                                    value: "National Bank of Kuwait (NBK)",
                                    label: "National Bank of Kuwait (NBK)",
                                  },
                                  {
                                    value: "National Bank of Abu Dhabi (NBAD)",
                                    label: "National Bank of Abu Dhabi (NBAD)",
                                  },
                                  {
                                    value: "Qatar National Bank (QNB)",
                                    label: "Qatar National Bank (QNB)",
                                  },
                                  {
                                    value: "Al Rajhi Bank (Rajhi)",
                                    label: "Al Rajhi Bank (Rajhi)",
                                  },
                                  {
                                    value: "Union National Bank (UNB)",
                                    label: "Union National Bank (UNB)",
                                  },
                                  {
                                    value: "Warba Bank (WRBA)",
                                    label: "Warba Bank (WRBA)",
                                  },
                                  {
                                    value: "Al Baraka Islamic Bank (AIB)",
                                    label: "Al Baraka Islamic Bank (AIB)",
                                  },
                                  {
                                    value: "Al-Salam Bank",
                                    label: "Al-Salam Bank",
                                  },
                                  {
                                    value: "Bahrain Islamic Bank (BisB)",
                                    label: "Bahrain Islamic Bank (BisB)",
                                  },
                                  {
                                    value: "Ithmaar Bank",
                                    label: "Ithmaar Bank",
                                  },
                                  {
                                    value: "Khaleeji Commercial Bank (KHCB)",
                                    label: "Khaleeji Commercial Bank (KHCB)",
                                  },
                                  { value: "Arab Bank", label: "Arab Bank" },
                                  {
                                    value: "Bahrain Development Bank (BDB)",
                                    label: "Bahrain Development Bank (BDB)",
                                  },
                                  {
                                    value: "Bank of Bahrain and Kuwait (BBK)",
                                    label: "Bank of Bahrain and Kuwait (BBK)",
                                  },
                                  {
                                    value: "BNP Paribas",
                                    label: "BNP Paribas",
                                  },
                                  { value: "Citibank", label: "Citibank" },
                                  {
                                    value: "Credit Libanais",
                                    label: "Credit Libanais",
                                  },
                                  { value: "Eskan Bank", label: "Eskan Bank" },
                                  {
                                    value: "Future Bank",
                                    label: "Future Bank",
                                  },
                                  {
                                    value: "Habib Bank (HBL)",
                                    label: "Habib Bank (HBL)",
                                  },
                                  {
                                    value: "HSBC Bank Middle East",
                                    label: "HSBC Bank Middle East",
                                  },
                                  { value: "ICICI Bank", label: "ICICI Bank" },
                                  { value: "Ila bank", label: "Ila bank" },
                                  {
                                    value: "National Bank of Bahrain (NBB)",
                                    label: "National Bank of Bahrain (NBB)",
                                  },
                                  {
                                    value: "Standard Chartered Bank (SCB)",
                                    label: "Standard Chartered Bank (SCB)",
                                  },
                                  {
                                    value: "State Bank of India (SBI)",
                                    label: "State Bank of India (SBI)",
                                  },
                                  {
                                    value:
                                      "The Housing Bank for Trade and Finance",
                                    label:
                                      "The Housing Bank for Trade and Finance",
                                  },
                                  {
                                    value: "Jordan United Bank Limited",
                                    label: "Jordan United Bank Limited",
                                  },
                                  {
                                    value: "United Bank Limited (UBL)",
                                    label: "United Bank Limited (UBL)",
                                  },
                                ]}
                                filterOption={(option, input) => {
                                  return normalize(option.label).includes(normalize(input));
                                }}
                                placeholder="Select an option"
                              />
                              {error.bankName !== undefined &&
                                error.bankName !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.bankName}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Name On Account
                              </label>
                              <input
                                id="bank_holder_name"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Account Holder Name"
                                data-error="* Enter Bank Account Holder Name"
                                value={data?.bankHolderName ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "bankHolderName");
                                }}
                              />
                              {error.bankHolderName !== undefined &&
                                error.bankHolderName !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.bankHolderName}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                IBAN
                              </label>
                              <input
                                id="bank_iban"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter IBAN Number"
                                data-error="* Please Enter IBAN"
                                value={data?.bankIban ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "bankIban");
                                }}
                              />
                              {error.bankIban !== undefined &&
                                error.bankIban !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.bankIban}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                SWIFT
                              </label>
                              <input
                                id="bank_swift"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter SWIFT Code"
                                data-error="* Please Enter SWIFT Code"
                                value={data?.bankSwift ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "bankSwift");
                                }}
                              />
                              {error.bankSwift !== undefined &&
                                error.bankSwift !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.bankSwift}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Bank account */}
                    {/* Start:Vehicle Info */}
                    <div className="row g-5 g-lg-10 mb-5">
                      {/*begin::Card*/}
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Vehicle Info</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Vehicle Type
                              </label>
                              <div className="fv-row">
                                {/*begin::Radio group*/}
                                <div
                                  className="btn-group w-100"
                                  data-kt-buttons="true"
                                  data-kt-buttons-target="[data-kt-button]"
                                >
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.vehicleType === "Car"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-driver-field"
                                      type="radio"
                                      name="vehicle_type"
                                      value="Car"
                                      data-error="* Select Vehicle Type"
                                      onClick={() => {
                                        processData(
                                          "vehicleType",
                                          "Car",
                                          "vehicleType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Car
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.vehicleType === "Motorcycle"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-driver-field"
                                      type="radio"
                                      name="vehicle_type"
                                      value="Motorcycle"
                                      data-error="* Select Vehicle Type"
                                      onClick={() => {
                                        processData(
                                          "vehicleType",
                                          "Motorcycle",
                                          "vehicleType"
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    Motorcycle
                                  </label>
                                  {/*end::Radio*/}
                                </div>
                                {/*end::Radio group*/}
                              </div>
                              {error.vehicleType !== undefined &&
                                error.vehicleType !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleType}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Make
                              </label>
                              <input
                                id="vehicle_make"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="e.g. Toyota"
                                data-error="* Please Enter Vehicle Make"
                                value={data?.vehicleMake ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "vehicleMake");
                                }}
                              />
                              {error.vehicleMake !== undefined &&
                                error.vehicleMake !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleMake}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Model
                              </label>
                              <input
                                id="vehicle_model"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="e.g. Corolla"
                                data-error="* Please Enter Model Number"
                                value={data?.vehicleModel ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "vehicleModel");
                                }}
                              />
                              {error.vehicleModel !== undefined &&
                                error.vehicleModel !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleModel}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Year
                              </label>
                              <input
                                id="vehicle_year"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter Year"
                                data-error="* Please Enter Year"
                                value={data?.vehicleYear ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "vehicleYear");
                                }}
                              />
                              {error.vehicleYear !== undefined &&
                                error.vehicleYear !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleYear}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Plate
                              </label>
                              <input
                                id="vehicle_plate"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Plate Number"
                                data-error="* Please Enter Plate Number"
                                value={data?.vehiclePlate ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "vehiclePlate");
                                }}
                              />
                              {error.vehiclePlate !== undefined &&
                                error.vehiclePlate !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehiclePlate}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Registration
                              </label>
                              <input
                                name="vehicle_registration"
                                id="vehicle_registration"
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Regstd. No."
                                data-error="* Enter Registration Number"
                                value={data?.vehicleRegistration ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "vehicleRegistration");
                                }}
                              />
                              {error.vehicleRegistration !== undefined &&
                                error.vehicleRegistration !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleRegistration}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Car Registration Document
                              </label>
                              <input
                                id="vehicle_document"
                                type="file"
                                className="form-control add-driver-field"
                                placeholder="Upload Car Registration"
                                data-error="* Upload Car Registration Document"
                                ref={vehicleInputRef}
                                onChange={(e) => {
                                  processData("file", e, "vehicleDocument");
                                }}
                              />
                              {error.vehicleDocument !== undefined &&
                                error.vehicleDocument !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.vehicleDocument}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "vehicleDocument" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                      </div>
                      {/*end::Card*/}
                    </div>
                    {/* End:Bank account */}
                    <button
                      type="button"
                      className={
                        isSubmitted === true
                          ? "btn btn-success me-2"
                          : "btn btn-primary me-2"
                      }
                      id="addDriverBtn"
                      onClick={() => {
                        addDriver();
                        setIsSubmitted(true);
                        setTimeout(() => {
                          setIsSubmitted(false);
                        }, 1000);
                      }}
                    >
                      <span className="indicator-label">Add Driver</span>
                      <span className="indicator-progress">
                        Please wait...{" "}
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        setIsReset(true);
                        setTimeout(() => {
                          setIsReset(false);
                        }, 1000);
                        reset();
                      }}
                      type="button"
                      className={
                        isReset === true
                          ? "btn btn-danger mx-2"
                          : "btn btn-primary mx-2"
                      }
                    >
                      Reset
                    </button>
                  </form>
                </PermissionGate>
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default CreateDriver;
